import moment from 'moment';

const validateWithoutState = (validators, errors) => {
  const e2 = {};
  validators.forEach((v) => {
    e2[v.fieldName] = !v.isValid(v.fieldValue);
  });
  const isInvalid = Object.keys(e2).reduce((accum, key) => accum || e2[key], false);
  //setErrors((errors) => ({ ...errors, ...e2 }));
  return !isInvalid;
  //return errors;
};

const validate = (validators, setErrors) => {
  const e2 = {};
  validators.forEach((v) => {
    e2[v.fieldName] = !v.isValid(v.fieldValue);
  });
  const isInvalid = Object.keys(e2).reduce((accum, key) => accum || e2[key], false);
  setErrors((errors) => ({ ...errors, ...e2 }));
  return !isInvalid;
};

const isSelected = (item) => {
  return item !== null && typeof item !== 'undefined';
};

const isSelecionComplete = (items) => {
  return items !== null && typeof items !== 'undefined' && items.length > 0;
};

const isCompleted = (val) => val && val.length >= 2;

const isNumeric = (val) => val && !isNaN(val);

const isNonNegativeInteger = (val) => {
  if (val === null || val === '') return true;
  const reg = /^0*[1-9][0-9]*$/i;
  return !!reg.test(String(val).toLowerCase());
};

const isDateValid = ({ day, month, year, date }) => {
  return !(
    !day ||
    isNaN(day) ||
    !month ||
    isNaN(month) ||
    !year ||
    isNaN(year) ||
    year < 1900 ||
    !moment(`${year}-${month}-${day}`).isValid()
  );
};

const isAustralianPhoneNumberOrNull = (number) => {
  if (!number) return true;
  const re = /^\({0,1}((0)(2|4|3|7|8)){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/i;
  return !(number === null || !re.test(String(number).toLowerCase()));
};

const isAustralianPhoneNumberWithCountryCodeOrNull = (number) => {
  if (!number) return true;
  const re = /^\({0,1}(0|2|4|3|7|8){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{4}$/i;
  return !(number === null || !re.test(String(number).toLowerCase()));
};

const isAustralianPhoneNumberWithOutCountryCodeOrNull = (number) => {
  if (!number) return true;
  const re = /^[0-9]{1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{4}$/i;
  return !(number === null || !re.test(String(number).toLowerCase()));
};

const isValidWebAddress = (webAddress) => {
  if (!webAddress) return true;
  const re = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/i;
  return !(webAddress === null || !re.test(String(webAddress).toLowerCase()));
};

const isAustralianPhoneNumber = (number) => {
  const re = /^\({0,1}((0)(2|4|3|7|8)){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/i;
  return !(number === null || !re.test(String(number).toLowerCase()));
};

const isDayMonthValue = (dayMonth) => {
  let isValid = false;
  //when 29/02 valid date with leap year
  if (dayMonth === '29/02') {
    const leapYear = dayMonth + '/2020';
    isValid = moment(leapYear, 'DD/MM/YYYY', true).isValid();
  } else {
    isValid = moment(dayMonth, 'DD/MM', true).isValid();
  }

  return !(dayMonth === null || !isValid);
};

const isFileUploaded = (val) => {
  return val && Array.isArray(val) && val.filter((v) => v.status === 'done').length;
};

const isDateValidAndPast = ({ day, month, year, date }) => {
  return !(
    !day ||
    isNaN(day) ||
    !month ||
    isNaN(month) ||
    !year ||
    isNaN(year) ||
    year < 1900 ||
    !moment(`${year}-${month}-${day}`).isValid() ||
    moment(`${year}-${month}-${day}`).isAfter(moment())
  );
};

const isAFutureDate = (day, month, year) => {
  if (year < 1900) return false;
  if (moment(`${year}-${month}-${day}`).isAfter(moment())) {
    return true;
  }

  return false;
};

const isDateValidAnd18Yo = ({ day, month, year, date }) => {
  return !(
    !day ||
    isNaN(day) ||
    !month ||
    isNaN(month) ||
    !year ||
    isNaN(year) ||
    year < 1900 ||
    !moment(`${year}-${month}-${day}`).isValid() ||
    !(moment().diff(`${year}-${month}-${day}`, 'years', true) >= 18) ||
    moment(`${year}-${month}-${day}`).isAfter(moment())
  );
};

const hasOwnershipData = ({ ownershipCorporations, ownershipPartners, ownershipTrusts, ownershipType }) => {
  if (ownershipType === 'self') {
    return true;
  }

  if (ownershipType === 'corporation') {
    if (ownershipCorporations.length > 0) {
      return true;
    } else {
      return false;
    }
  } else if (ownershipType === 'partner') {
    if (ownershipPartners.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  if (ownershipType === 'trust') {
    if (ownershipTrusts.length > 0) {
      return true;
    } else {
      return false;
    }
  }
};

const hasAnyValue = (array) => {
  return array && array.length > 0;
};

const isValidEmail = (email) => {
  const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return !(email === null || !re.test(String(email).toLowerCase()));
};

const isAddressValid = (address) => {
  if (!address) {
    return false;
  } else {
    if (address.customType) {
      const a = address.value.details;
      return (
        a &&
        a.addressLine1 &&
        a.addressLine1.length > 2 &&
        a.suburb &&
        a.suburb.length > 2 &&
        a.state &&
        a.state.value !== null &&
        a.postcode &&
        a.postcode.length > 2 &&
        (!address.international || (address.international && a.country && a.country.length > 2))
      );
    } else {
      return true;
    }
  }
};

const clearError = (errName, errors, setErrors) => {
  const e2 = { ...errors };
  e2[errName] = false;
  setErrors(e2);
};

const clearErrors = (errors, setErrors) => {
  const e2 = { ...errors };
  Object.keys(e2).forEach((errName) => (e2[errName] = false));
  setErrors(e2);
};

const scrollToError = (errorSequences, errors) => {
  window.setTimeout(() => {
    // const errorElements = document.querySelectorAll("[class*=ErrorMsg_error]");
    const errorElements = document.querySelectorAll('[class*=error]');
    if (errorElements && errorElements.length > 0) {
      const yOffset = -150;
      const y = errorElements[0].getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }, 100);

  let flagRefSet = false;
  /*
    errorSequences.map((obj)=>{
      if(flagRefSet==false && errors[obj.errorKey]==true){
        obj.refError.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
        obj.refError.current.focus();
        flagRefSet = true;
      }
    });
    */
};

export {
  clearError,
  clearErrors,
  isSelected,
  isCompleted,
  isDateValid,
  isDateValidAndPast,
  isDateValidAnd18Yo,
  hasAnyValue,
  isNumeric,
  isNonNegativeInteger,
  isValidEmail,
  isAddressValid,
  isSelecionComplete,
  validate,
  isFileUploaded,
  isAustralianPhoneNumber,
  isAustralianPhoneNumberOrNull,
  isAustralianPhoneNumberWithCountryCodeOrNull,
  isAustralianPhoneNumberWithOutCountryCodeOrNull,
  scrollToError,
  isAFutureDate,
  hasOwnershipData,
  isValidWebAddress,
  isDayMonthValue,
  validateWithoutState
};
